import React, { useEffect, useState } from 'react';
import { testAPI, testRoutes } from '../utils/apiTest';

const APITestPage = () => {
  const [testResults, setTestResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const runTests = async () => {
    setLoading(true);
    setTestResults([]);
    
    const results = [];
    
    // Test conexión básica
    console.log('=== INICIANDO PRUEBAS DE API ===');
    results.push('🔄 Iniciando pruebas...');
    setTestResults([...results]);

    // Test conectividad
    const isConnected = await testAPI();
    results.push(isConnected ? '✅ Conexión exitosa' : '❌ No se puede conectar');
    setTestResults([...results]);

    if (isConnected) {
      results.push('🔄 Probando rutas específicas...');
      setTestResults([...results]);
      await testRoutes();
    }

    results.push('✅ Pruebas completadas');
    setTestResults([...results]);
    setLoading(false);
  };

  useEffect(() => {
    runTests();
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg p-6">
          <h1 className="text-2xl font-bold text-gray-900 mb-6">
            🔧 Pruebas de Conexión API Laravel
          </h1>
          
          <div className="mb-6">
            <button
              onClick={runTests}
              disabled={loading}
              className="bg-blue-600 hover:bg-blue-700 disabled:bg-blue-300 text-white px-4 py-2 rounded font-medium"
            >
              {loading ? 'Probando...' : 'Ejecutar Pruebas'}
            </button>
          </div>

          <div className="bg-gray-900 text-green-400 p-4 rounded-lg font-mono text-sm">
            <h3 className="text-white mb-2">📊 Resultados:</h3>
            {testResults.map((result, index) => (
              <div key={index} className="py-1">
                {result}
              </div>
            ))}
            {testResults.length === 0 && (
              <div className="text-gray-500">Esperando resultados...</div>
            )}
          </div>

          <div className="mt-6 p-4 bg-blue-50 rounded-lg">
            <h3 className="font-bold text-blue-900 mb-2">💡 Instrucciones:</h3>
            <ul className="text-blue-800 space-y-1 text-sm">
              <li><strong>1.</strong> Asegúrate de que Laravel esté corriendo: <code className="bg-blue-200 px-1 rounded">php artisan serve</code></li>
              <li><strong>2.</strong> Verifica que tu API esté en: <code className="bg-blue-200 px-1 rounded">http://localhost:8000</code></li>
              <li><strong>3.</strong> Configura las rutas según el archivo BACKEND-SETUP.md</li>
              <li><strong>4.</strong> Abre la consola del navegador (F12) para ver más detalles</li>
            </ul>
          </div>

          <div className="mt-6 p-4 bg-yellow-50 rounded-lg">
            <h3 className="font-bold text-yellow-900 mb-2">🚨 Errores Comunes:</h3>
            <ul className="text-yellow-800 space-y-1 text-sm">
              <li><strong>ECONNREFUSED:</strong> Laravel no está corriendo</li>
              <li><strong>404:</strong> Rutas no configuradas en routes/api.php</li>
              <li><strong>CORS:</strong> Configurar config/cors.php</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default APITestPage;
